import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import {
  fetchNotifications,
  markAllNotificationDoneFailure,
  markAllNotificationDoneSuccess,
} from "domains/notifications/actions";

export function* markAllDoneSaga() {
  try {
    yield apiFetch("notification", {
      queryParams: { mark: "all" },
      method: "PUT",
    });
    yield put(markAllNotificationDoneSuccess());
    yield put(fetchNotifications({ offset: 0 }));
  } catch {
    yield put(markAllNotificationDoneFailure({ logoutOnAuthError: true }));
  }
}
